import { RESET_STATE } from 'store/global/actions';

import { PRICING_ACTION_TYPE } from '../actions';

const initialState = {
  pricing: {},
  counties: [],
  isLoanNotQualifiedProgramsHidden: null,
};

const pricingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PRICING_ACTION_TYPE.CREATE_PRICING:
      return { ...state, pricing: payload };

    case PRICING_ACTION_TYPE.GET_COUNTIES_BY_STATE:
      return { ...state, counties: payload };

    case PRICING_ACTION_TYPE.SET_IS_LOAN_NOT_QUALIFIED_PROGRAMS_HIDDEN:
      return { ...state, isLoanNotQualifiedProgramsHidden: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default pricingReducer;
